import { useContext, useEffect, useState } from 'react';
import styles from '../../../shared/NewUserModal.module.scss';
import CustomSelect from 'react-select';
import { myUserDataContext } from '../../../App';
import axios from 'axios';
import { debounce, set } from 'lodash';
import { responseHandler } from '../../../functions/responseHandler';
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { useNavigate, useParams } from 'react-router-dom';
import { notify } from '../../../functions/toasts';
import Loading from '../../../shared/Loading';

const CopyLandingModal = ({ id }) => {
  const data = useContext(myUserDataContext);
  const navigate = useNavigate();
  const { userData, isLogin, mainUrl, keySearch } = data;
  const { token, user } = userData;
  const [location, setLocation] = useState('5040');
  const [createTokenStep, setCreateTokenStep] = useState(false);
  const [products, setProducts] = useState([]);
  const [agencies, setAgencies] = useState([]);
  const [productId, setProductId] = useState(null);
  const [agencyId, setAgencyId] = useState(null);
  const [editeLanding, setEditeLanding] = useStateWithCallbackLazy(
    {}
  );
  const [title, setTitle] = useState('');
  const [type, setType] = useState('');
  const [templateId, setTemplateId] = useState('');
  const [checkBtnCopy, setCheckBtnCopy] = useState(false);
  const [mainLand, setMainLand] = useState(null);
  const [selectOptions, setSelectOptions] = useState({
    subject: [],
    label: [],
    // type: [],
  });
  const [tokenList, setTokenList] = useState([]);
  const [newToken, setNewToken] = useState(null);
  const [newTokenList, setNewTokenList] = useState(null);
  const [subject, setSubject] = useState(null);
  const [label, setLabel] = useState(null);
  const [isLoad, setIsLoad] = useState(false);
  const [isLoadCreate, setIsLoadCreate] = useState(false);

  useEffect(() => {
    if (id) {
      setIsLoad(true);
      axios
        .get(
          `/landing/show/${id}?relations[]=groups&relations[]=parameterGroup.variants`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(async (res) => {
          setIsLoad(false);
          responseHandler(res, 'succ', false);
          if (res.data.status) {
            const {
              parameters,
              is_child,
              // is_refrence,
              landing_group,
              parameter_group,
            } = res.data.data;

            setEditeLanding({
              slug: '',
              description: '',
              parameters: JSON.parse(parameters),
              template_id: '',
              is_child,
              // is_refrence,
              parameter_group,
              landing_group,
            });

            await axios
              .get(`/template/show/${res.data.data.template_id}`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              })
              .then((res2) => {
                if (res2.data.status) {
                  setTemplateId(res2.data.data.id);
                }
              })
              .catch((error2) => {
                responseHandler(error2, 'error');
              });
          }
        })
        .catch((error) => {
          setIsLoad(false);
          responseHandler(error, 'error');
          // if (error.response?.status === 404)
          //   navigate('/notfound', { replace: true });
        });
    }
  }, [id]);

  const fetchProducts = async (name = '') => {
    try {
      const url = name
        ? `/proxy_api/get-products?location=${location}&name=${encodeURIComponent(
            name
          )}`
        : `/proxy_api/get-products?location=${location}`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status) {
        const options = res.data.data.data?.map((item) => ({
          label: item.name,
          value: item._id,
        }));
        setProducts(options);
      }
    } catch (err) {
      responseHandler(err, 'error');
    }
  };

  const debouncedFetch = debounce((value) => {
    if (value.length >= 2) {
      fetchProducts(value);
    }
  }, 500);

  const handleInputChange = (value) => {
    debouncedFetch(value);
  };

  //   const handleChangeProducts = (selectedOption) => {
  //     setTemplateSearch(selectedOption);
  //   };

  const fetchAgencies = async (name = '') => {
    try {
      const url = name
        ? `/proxy_api/get-agencies?location=${location}&name=${encodeURIComponent(
            name
          )}`
        : `/proxy_api/get-agencies?location=${location}`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status) {
        const options = res.data.data.data?.map((item) => ({
          label: item.name,
          value: item._id,
        }));
        setAgencies(options);
      }
    } catch (err) {
      responseHandler(err, 'error');
    }
  };

  const debouncedFetchAgencies = debounce((value) => {
    if (value.length >= 2) {
      fetchAgencies(value);
    }
  }, 500);

  const handleInputChangeAgencies = (value) => {
    debouncedFetchAgencies(value);
  };

  const handleChangeAgency = (selectedOption) => {
    setAgencyId(selectedOption);
  };

  const fetchTokenList = async (name = '') => {
    try {
      const queryParams = new URLSearchParams({
        location,
      });

      if (agencyId?.value && productId?.value) {
        queryParams.append('product', productId.value);
        queryParams.append('agency', agencyId.value);
      }

      if (name) {
        // queryParams.append('name', name);
        queryParams.append('token', name);
      }

      const url = `/proxy_api/landing-token-list?${queryParams.toString()}`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status) {
        console.log('bbbbbbbbbbbbbbbbbbbb');

        setTokenList(res.data.data.data);
      }
    } catch (err) {
      responseHandler(err, 'error');
    }
  };

  const debouncedFetchToken = debounce((value) => {
    if (value.length >= 2) {
      fetchTokenList(value);
    }
  }, 500);

  const handleInputChangeTokenList = (value) => {
    debouncedFetchToken(value);
  };

  const handleChangeToken = (selectedOption) => {
    setNewTokenList(selectedOption);
    setNewToken(null);
  };

  const handleChangeSubject = (selectedOption) => {
    setSubject(selectedOption);
  };

  const handleChangeLabel = (selectedOption) => {
    setLabel(selectedOption);
  };

  const getSelectOptions = () => {
    setIsLoad(true);
    axios
      .get('/landing/get-landing-subjects', {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        if (res.data.status) {
          setIsLoad(false);
          setSelectOptions({
            subject: res.data.subjects,
            label: res.data.labels,
          });
        } else {
          setIsLoad(false);
          responseHandler(res, 'error');
        }
      })
      .catch((error) => {
        setIsLoad(false);
        responseHandler(error, 'error');
      });
  };

  useEffect(() => {
    if (createTokenStep) {
      fetchProducts();
      fetchAgencies();
    }
  }, [location, createTokenStep]);

  useEffect(() => {
    setAgencyId(null);
    setProductId(null);
    setNewTokenList(null);
    setNewToken(null);
    setSubject(null);
    setLabel(null);
  }, [location]);

  useEffect(() => {
    fetchTokenList();
  }, [productId, agencyId, location]);

  useEffect(() => {
    if (editeLanding?.landing_group?.length) {
      const filtredlandPara =
        editeLanding?.landing_group?.[0]?.groups.filter(
          (item) => item.pivot.priority == 1
        );

      setMainLand(filtredlandPara);
    }
  }, [editeLanding]);

  const handleChangeProduct = (selectedOption) => {
    setProductId(selectedOption);
  };

  const requestToken = () => {
    setCreateTokenStep(true);
  };

  const createToken = () => {
    setIsLoadCreate(true);
    const body = {
      name: title,
      product_id: productId?.value || '',
      agency_id: agencyId?.value || '',
      location: location,
      mobile: user.mobile,
    };
    axios
      .post('/proxy_api/create-landing-token', body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setIsLoadCreate(false);

        responseHandler(res, 'succ');
        if (res.data.status) {
          setNewToken(res.data.data.data.token);
          setNewTokenList(null);
          notify('توکن ایجاد شد', 'success');
        }
        setCheckBtnCopy(false);
      })
      .catch((error) => {
        responseHandler(error, 'error');
        setCheckBtnCopy(false);
        setIsLoadCreate(false);
      });
  };

  useEffect(() => {
    getSelectOptions();
  }, []);

  const CopyLandingHandler = () => {
    setCheckBtnCopy(true);
    setIsLoad(true);

    const formData = new FormData();

    //  const filteredvariants = othersParameters?.variants || [];

    //  const filteredLandings = landings.landings || [];

    const parameters = {
      ...editeLanding.parameters,
      token: newTokenList?.value ?? newToken,
      ...(location === 'hamkadeh' && {
        subject: subject?.value,
        subjectSelect: subject?.value,
        label: label?.value,
        labelSelect: label?.value,
      }),
    };

    const sanitizeVariants = (parameterGroup) => {
      const tokenKeys = ['token'];
      const labelKeys = ['labelSelect', 'label'];
      const subjectKeys = ['subjectSelect', 'subject'];

      parameterGroup.variants = parameterGroup.variants.map(
        (variant) => {
          let paramsStr = variant.parameters;

          try {
            while (typeof paramsStr === 'string') {
              paramsStr = JSON.parse(paramsStr);
            }
          } catch (e) {
            console.error('خطا در پارس کردن پارامترها:', e);
            paramsStr = {};
          }

          const replacedParams = Object.fromEntries(
            Object.entries(paramsStr).map(([key, value]) => {
              if (tokenKeys.includes(key)) {
                return [key, newTokenList?.value ?? newToken];
              }
              if (
                labelKeys.includes(key) &&
                location === 'hamkadeh'
              ) {
                return [key, label?.value];
              }
              if (
                subjectKeys.includes(key) &&
                location === 'hamkadeh'
              ) {
                return [key, subject?.value];
              }
              return [key, value];
            })
          );

          return {
            ...variant,
            parameters: replacedParams,
          };
        }
      );

      return parameterGroup;
    };

    const sanitized = sanitizeVariants(editeLanding.parameter_group);

    formData.append('title', title);
    //  formData.append('slug', editeLanding.slug);
    formData.append('description', editeLanding.description);
    formData.append(
      'parameters',
      JSON.stringify({
        parameters,
        baseAndMainTitle: title,
        subjectSelect:
          location === '5040'
            ? editeLanding.parameters.subjectSelect ??
              editeLanding.parameters.subject
            : subject?.value,
        labelSelect:
          location === '5040'
            ? editeLanding.parameters.labelSelect ??
              editeLanding.parameters.label
            : label?.value,
      })
    );
    formData.append('template_id', templateId);
    formData.append('user_id', userData.user.id);

    if (editeLanding?.landing_group?.[0]) {
      if (editeLanding?.landing_group?.[0]?.CTR_target)
        formData.append(
          'landing_group[CTR_target]',
          editeLanding?.landing_group?.[0]?.CTR_target
        );

      formData.append(
        'landing_group[change_type]',
        editeLanding?.landing_group?.[0]?.change_type
      );

      editeLanding?.landing_group?.[0]?.groups?.forEach(
        (landing, index) => {
          if (landing?.pivot?.priority !== 1) {
            if (landing?.landing_id)
              formData.append(
                `landing_group[landings][${index}][id]`,
                landing?.landing_id
              );
            if (landing?.pivot?.priority)
              formData.append(
                `landing_group[landings][${index}][priority]`,
                landing?.pivot?.priority
              );
            if (landing?.pivot?.time_change)
              formData.append(
                `landing_group[landings][${index}][time_change]`,
                landing?.pivot?.time_change
              );
            if (landing?.pivot?.view_change)
              formData.append(
                `landing_group[landings][${index}][view_change]`,
                landing?.pivot?.view_change
              );
          }
        }
      );
    }

    if (
      editeLanding?.parameter_group &&
      editeLanding.parameter_group.CTR_target !== ''
    ) {
      formData.append(
        'parameter_group[CTR_target]',
        editeLanding.parameter_group.CTR_target
      );
    }

    if (editeLanding?.parameter_group)
      formData.append(
        'parameter_group[change_type]',
        editeLanding.parameter_group.change_type
      );

    if (editeLanding?.parameter_group) {
      sanitized?.variants?.forEach((item, index) => {
        if (index === 0) return;

        formData.append(
          `parameter_group[variants][${index}][parameters]`,
          JSON.stringify(item.parameters)
        );

        if (item.priority)
          formData.append(
            `parameter_group[variants][${index}][priority]`,
            item.priority
          );
        if (item.time_change)
          formData.append(
            `parameter_group[variants][${index}][time_change]`,
            item.time_change
          );
        if (item.view_change)
          formData.append(
            `parameter_group[variants][${index}][view_change]`,
            item.view_change
          );
      });
    }
    formData.append('is_child', editeLanding.is_child);
    // formData.append('is_refrence', editeLanding.is_refrence);

    if (mainLand?.[0]?.pivot?.time_change) {
      formData.append(
        'time_change',
        mainLand?.[0]?.pivot?.time_change
      );
    }

    formData.append(
      'parameter_change',
      editeLanding?.parameter_group?.variants?.[0]?.view_change ??
        editeLanding?.parameter_group?.variants?.[0]?.time_change
    );

    if (mainLand?.[0]?.pivot?.view_change) {
      formData.append(
        'view_change',
        mainLand?.[0]?.pivot?.view_change
      );
    }

    if (editeLanding.parameters.subjectSelect !== '') {
      const bodyPanel = {
        landing_token: newTokenList?.value ?? newToken,
        location:
          editeLanding.parameters.HamkadehOrNot === ''
            ? 'hamkadeh'
            : editeLanding.parameters.HamkadehOrNot === '1'
            ? 'old_5040'
            : '5040',
        type: type,
        subject:
          location === '5040'
            ? editeLanding.parameters.subjectSelect ??
              editeLanding.parameters.subject
            : subject?.value,
        ...((editeLanding.parameters.labelSelect !== '' ||
          editeLanding.parameters.label) && {
          label:
            location === '5040'
              ? editeLanding.parameters.labelSelect ??
                editeLanding.parameters.label
              : label?.value,
        }),
      };

      axios
        .post(`/landing/send-landing-subjects`, bodyPanel, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setIsLoadCreate(false);
          if (res.data.status) {
            //for install
            axios
              .post('/landing/create', formData, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              })
              .then((res) => {
                setIsLoadCreate(false);
                responseHandler(res, 'succ');
                if (res.data.status) {
                  window.location.reload();
                }
                setCheckBtnCopy(false);
              })
              .catch((error) => {
                setIsLoadCreate(false);
                responseHandler(error, 'error');
                setCheckBtnCopy(false);
              });
          } else {
            setIsLoadCreate(false);
            notify('توکن وب سرویس وارد شده اشتباه است', 'error');
            setCheckBtnCopy(false);
          }
        })
        .catch((error) => {
          setIsLoadCreate(false);

          responseHandler(error, 'error');
        });
    } else {
      //for install
      axios
        .post('/landing/create', formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setIsLoadCreate(false);

          responseHandler(res, 'succ');
          if (res.data.status) {
            window.location.reload();
          }
          setCheckBtnCopy(false);
        })
        .catch((error) => {
          setIsLoadCreate(false);
          responseHandler(error, 'error');
          setCheckBtnCopy(false);
        });
    }
  };

  const disabledCheck =
    title === '' ||
    type === '' ||
    (!newTokenList?.value && !newToken) ||
    (location === 'hamkadeh' && !subject) ||
    (location === 'hamkadeh' && !label);

  const disabledCheckCreate =
    title === '' || productId === null || agencyId === null;

  console.log(tokenList, 'tokenList');

  return (
    <div
      className="modal fade"
      id="newCopyModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog  modal-dialog-centered">
        <div className="modal-content">
          {isLoad ? (
            <Loading />
          ) : (
            <>
              <div className="modal-header">
                <h1
                  className="modal-title fs-5"
                  id="exampleModalLabel"
                >
                  کپی اتومات
                </h1>
              </div>
              <div className="modal-body">
                <div className={styles.divNewUser}>
                  <>
                    <div
                      style={{
                        display: 'flex',
                        marginBottom: 20,
                        justifyContent: 'space-between',
                      }}
                    >
                      <p style={{ fontWeight: 'bold', fontSize: 16 }}>
                        شرکت را انتخاب کنید:
                      </p>

                      <div style={{ width: '50%' }}>
                        <select
                          className="form-select"
                          value={location}
                          onChange={(e) =>
                            setLocation(e.target.value)
                          }
                        >
                          <option value="5040" defaultChecked>
                            5040
                          </option>
                          <option value="hamkadeh">همکده</option>
                        </select>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        marginBottom: 20,
                      }}
                    >
                      <input
                        style={{
                          backgroundColor: '#fff',
                          borderRadius: 10,
                          width: '50%',
                          margin: 10,
                          padding: 10,
                        }}
                        type="text"
                        placeholder="عنوان لندینگ ..."
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />

                      <input
                        style={{
                          backgroundColor: '#fff',
                          borderRadius: 10,
                          width: '50%',
                          margin: 10,
                          padding: 10,
                        }}
                        type="text"
                        placeholder="تایپ لندینگ ..."
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                      />
                    </div>
                    {location === 'hamkadeh' && (
                      <div
                        style={{
                          display: 'flex',
                          marginBottom: 20,
                        }}
                      >
                        <div style={{ width: '50%', margin: 10 }}>
                          <CustomSelect
                            options={selectOptions?.subject?.map(
                              (s) => ({
                                label: s.name,
                                value: s.id,
                              })
                            )}
                            placeholder="موضوع"
                            isClearable
                            isSearchable={false}
                            onChange={handleChangeSubject}
                          />
                        </div>
                        <div style={{ width: '50%', margin: 10 }}>
                          <CustomSelect
                            options={selectOptions?.label?.map(
                              (s) => ({
                                label: s.name,
                                value: s.id,
                              })
                            )}
                            placeholder="برچسب"
                            isClearable
                            isSearchable={false}
                            onChange={handleChangeLabel}
                          />
                        </div>
                      </div>
                    )}

                    {!createTokenStep && (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-around',
                        }}
                      >
                        <div style={{ width: '50%', margin: 10 }}>
                          {location === 'hamkadeh' ? (
                            <CustomSelect
                              options={tokenList.map((t) => ({
                                label: t.token,
                                value: t.id,
                              }))}
                              placeholder="توکن وب سرویس"
                              onInputChange={
                                handleInputChangeTokenList
                              }
                              isClearable
                              isSearchable
                              onChange={handleChangeToken}
                            />
                          ) : (
                            <CustomSelect
                              options={tokenList.map((token) => ({
                                label: token,
                                value: token,
                              }))}
                              placeholder="توکن وب سرویس"
                              onInputChange={
                                handleInputChangeTokenList
                              }
                              isClearable
                              isSearchable
                              onChange={handleChangeToken}
                            />
                          )}
                        </div>
                        <div style={{ width: '50%', margin: 10 }}>
                          <button
                            onClick={requestToken}
                            className="btn btn-warning btn-sm"
                            style={{
                              borderRadius: 10,
                              color: 'white',
                              width: 150,
                              height: 50,
                              textAlign: 'center',
                              fontWeight: 'bold',
                            }}
                          >
                            <span>درخواست توکن جدید</span>
                          </button>
                        </div>
                      </div>
                    )}

                    {createTokenStep && (
                      <>
                        <div
                          style={{
                            display: 'flex',
                            marginTop: 20,
                          }}
                        >
                          <div
                            style={{
                              width: '50%',
                              margin: 10,
                            }}
                          >
                            <CustomSelect
                              options={products}
                              placeholder="نام محصول"
                              onInputChange={handleInputChange}
                              onChange={handleChangeProduct}
                              isClearable
                              isSearchable
                            />
                          </div>

                          <div
                            style={{
                              width: '50%',
                              margin: 10,
                            }}
                          >
                            <CustomSelect
                              options={agencies}
                              placeholder="عاملیت"
                              onInputChange={
                                handleInputChangeAgencies
                              }
                              onChange={handleChangeAgency}
                              isClearable
                              isSearchable
                            />
                          </div>
                        </div>

                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-around',
                          }}
                        >
                          {isLoadCreate ? (
                            <Loading />
                          ) : (
                            <>
                              <div
                                style={{ width: '50%', margin: 10 }}
                              >
                                <button
                                  disabled={disabledCheckCreate}
                                  onClick={createToken}
                                  className="btn btn-warning btn-sm"
                                  style={{
                                    backgroundColor:
                                      disabledCheckCreate
                                        ? '#ddd'
                                        : '',
                                    borderRadius: 10,
                                    color: 'white',
                                    width: 150,
                                    height: 50,
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  <span>ایجاد توکن جدید</span>
                                </button>
                              </div>
                              <div
                                style={{ width: '50%', margin: 10 }}
                              >
                                <button
                                  onClick={() => {
                                    setCreateTokenStep(false);
                                  }}
                                  className="btn btn-danger btn-sm"
                                  style={{
                                    borderRadius: 10,
                                    color: 'white',
                                    width: 150,
                                    height: 50,
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  <span>انصراف</span>
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </>
                </div>
              </div>
              <div
                className="modal-footer"
                style={{ direction: 'ltr' }}
              >
                <button
                  type="button"
                  className="btn btn-secondary"
                  id="closeNewUserModal"
                  data-bs-dismiss="modal"
                >
                  بستن
                </button>
                <button
                  style={{
                    backgroundColor: disabledCheck ? '#ddd' : '',
                  }}
                  type="button"
                  className="btn btn-primary"
                  onClick={CopyLandingHandler}
                  disabled={disabledCheck}
                >
                  کپی کردن
                  {/* {checkBtnDownload ? (
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            <i className="bi bi-file-spreadsheet-fill me-2"></i>
          )} */}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CopyLandingModal;
